import { render, staticRenderFns } from "./FeeDialog.vue?vue&type=template&id=6472007c&scoped=true&"
import script from "./FeeDialog.vue?vue&type=script&lang=js&"
export * from "./FeeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6472007c",
  null
  
)

export default component.exports